import { mapState } from 'vuex';

export const rules = {
	computed: {
		...mapState(['user']),
		...mapState('playbooks', ['rules']),
	},
	methods: {
		/**
		 * Determine if the user has access to the given rule.
		 *
		 * @param {string} slug The rule's slug.
		 *
		 * @returns {boolean} true if the user has access, false otherwise.
		 */
		ruleAvailable(slug) {
			return this.user.ruleTypes.includes(slug);
		},
		/**
		 * Gets the rule object (with rule data) for the given slug.
		 *
		 * @param {string} slug The rule slug.
		 *
		 * @returns {Object|null} The rule object or null.
		 */
		getRuleBySlug(slug) {
			const ruleObject = this.rules.filter((rule) => {
				return rule.id === slug;
			});

			return ruleObject[0] || null;
		},
	},
};
